import React, { useEffect, useState } from 'react'
import { InboxOutlined } from '@ant-design/icons'
import { UploadProps, message, Upload, UploadFile } from 'antd'
import type { UploadRequestOption } from 'rc-upload/lib/interface'
import { uploadFileToGCS } from '../../../../service/gcs-upload.service'

const { Dragger } = Upload

export const UploadImg = ({
    onUploadImgSuccess,
    initialValue,
    onUploadImgDelete,
}: {
    onUploadImgSuccess: (url: string, id: string) => void
    initialValue: string | undefined
    onUploadImgDelete: () => void
}): JSX.Element => {
    const [imageUrl, setImageUrl] = useState<string>('')
    const [previewImageContent, setPreviewImageContent] = useState<UploadFile[]>([])

    useEffect(() => {
        if (initialValue) {
            const urlSegments = initialValue.split('/')
            const lastSegment = urlSegments[urlSegments.length - 1]
            const fileName = lastSegment.split('?')[0]
            setImageUrl(initialValue)
            setPreviewImageContent([{ url: initialValue, uid: '', name: fileName }])
        }
    }, [initialValue])

    const customRequest = async (options: UploadRequestOption) => {
        const { file, onProgress, onSuccess, onError } = options
        try {
            const result = await uploadFileToGCS(
                file as File,
                'image',
                (percent) => onProgress?.({ percent } as unknown as ProgressEvent)
            )
            setImageUrl(result.url)
            message.success(`${(file as File).name} อัปโหลดไฟล์เสร็จสิ้น`)
            onUploadImgSuccess(result.url, result.id)
            onSuccess?.(result)
        } catch (err) {
            message.error(
                `${(file as File).name} อัปโหลดไฟล์ล้มเหลว: ${(err as Error).message}`
            )
            onError?.(err as Error)
        }
    }

    const uploadProps: UploadProps = {
        name: 'image',
        multiple: false,
        accept: 'image/jpg, image/png, image/jpeg',
        maxCount: 1,
        fileList: previewImageContent,
        customRequest,
        onChange(info) {
            setPreviewImageContent(info.fileList)
        },
        onPreview: async (file: UploadFile) => {
            window.open(file.url || file.response?.url, '_blank')
        },
        onRemove: () => {
            onUploadImgDelete()
            return true
        },
    }

    return (
        <>
            <Dragger {...uploadProps}>
                {previewImageContent.length === 0 && (
                    <>
                        <p className="ant-upload-drag-icon">
                            <InboxOutlined />
                        </p>
                        <p className="ant-upload-text">เลือกไฟล์หรือลากมาที่นี่</p>
                        <p className="ant-upload-hint">
                            อัตราส่วนที่แนะนำคือ 16:9
                            <br />
                            รองรับการอัปโหลดไฟล์ PNG, JPG, JPEG ครั้งละ 1
                            รูปภาพเท่านั้น
                        </p>
                    </>
                )}
                {previewImageContent.length > 0 && (
                    <img
                        src={imageUrl}
                        alt="Preview"
                        style={{ width: '507px', height: '285px' }}
                    />
                )}
            </Dragger>
        </>
    )
}
